const Reducer = (state, action) => {
    const anonymous = () => {
        return {
                    isAuthenticated: false,
                    name:"Agent Smith",
                    email:"",
                    picture:"http://s3.amazonaws.com/Survey_Pics/surveys/pic1s/000/000/125/original/agent-smith-vs-elf-matrix-lord-of-the-rings-funpoll-fun.png"
                }
    }
    switch (action.type) {
        case 'ADD_FILTERS':
            return {
                ...state,
                filters: Object.assign({}, state.filters, action.payload)
            };
        case 'REMOVE_FILTERS':
            const newFilters = state.filters
            for(var p in action.payload){
                delete(newFilters[p])
            }
            return {
                ...state,
                filters: newFilters
            };
        case 'LOGIN_USER':
            return {
                ...state,
                user: Object.assign({}, action.payload, {isAuthenticated: true})
            };
        case 'LOGOUT_USER':
            return {
                ...state,
                user: state.anonymous
            }
        default:
            return state;
    }
};

export default Reducer;